import { render, staticRenderFns } from "./boxGirder.vue?vue&type=template&id=1e4f280c&scoped=true&lang=pug"
import script from "./boxGirder.vue?vue&type=script&lang=js"
export * from "./boxGirder.vue?vue&type=script&lang=js"
import style0 from "./boxGirder.vue?vue&type=style&index=0&id=1e4f280c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4f280c",
  null
  
)

export default component.exports